import React from 'react';
import './wq-integration.css';

const PlusIcon = () => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
        <path d="M6 1v10M1 6h10" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
);

// One collapsible card per SDK / plugin. Open state lives in the page so only
// one card is open at a time. The header is a real <button>, so it works with
// the keyboard and screen readers.
function Accordion({ id, title, tag, isOpen, onToggle, children }) {
    const panelId = `${String(id).replace(/[^a-z0-9]+/gi, '-').toLowerCase()}-panel`;

    return (
        <div id={id} className={`wq-acc${isOpen ? ' open' : ''}`}>
            <h3 className="wq-acc-heading">
                <button
                    type="button"
                    className="wq-acc-head"
                    aria-expanded={isOpen}
                    aria-controls={panelId}
                    onClick={onToggle}
                >
                    <span className="wq-acc-title">{title}</span>
                    {tag && <span className="wq-cond">{tag}</span>}
                    <span className="wq-acc-icon">
                        <PlusIcon />
                    </span>
                </button>
            </h3>

            {isOpen && (
                <div id={panelId} className="wq-acc-body">
                    {children}
                </div>
            )}
        </div>
    );
}

export default Accordion;